import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';

// TODO: remove useSetUi and use the Mgr directly
/**
 * Hook for handling the UI state
 */
const useSetUI = () => {
	const {managerRepository} = useGeneralProvider();

	return managerRepository.getUiMgr();
};

export default useSetUI;
